import { useToast } from 'alm-react-components';
import { useContext, useEffect, useLayoutEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { APPROUTES, constants, ErrorType, FileNotation, Tag } from '../../../assets/constants/constants';
import { AppContext } from '../../../context/AppProvider';
import { ProgramDetailObjectType } from '../../../interface';
import getLocalizedContent from '../../../lib/getLocalizedMetaData';
import { checkLottie, filterEnrollmentData, getBadgeDetail } from '../../../lib/utils';
import { apis } from '../../../services/alm';
import PageLoader from '../../common/loader/PageLoader';
import { FullScreenPlayer } from '../../common/player/FullScreenPlayer';
import RelatedContent from '../course-detail/RelatedContent';
import ClassResources from './ClassResources';
import { ProgramInstructions } from './ProgramInstructions';
import { ProgramIntroContent } from './ProgramIntroContent';

type CourseDetailProps = {
  cid: string;
};
const ProgramIntro: React.FC<CourseDetailProps> = Props => {
  const { t } = useTranslation();
  const { toast } = useToast();
  const [data, setData] = useState<any>();
  const [playCourse, setPlayCourse] = useState(false);
  const [classResource, setClassResource] = useState<[]>([]);
  const [courseDetails, setCourseDetails] = useState<any>();
  const [programDetailObject, setProgramDetailObject] = useState<ProgramDetailObjectType>();
  const [jobAids, setJobAids] = useState();
  const [badgeDetailData, setBadgeDetailData] = useState();
  const [programId, setProgramId] = useState<string>('');
  const [userEnrollmentDate, setUserEnrollmentDate] = useState<any>();
  const [userEnrollmentId, setUserEnrollmentId] = useState<any>();
  const [fundamentalProgram, setFundamentalProgram] = useState(true);
  const [programFinishLottieLocation, setProgramFinishLottieLocation] = useState<string>('');
  const [programBadgeLottieLocation, setProgramBadgeLottieLocation] = useState<string>('');
  const [learningProgramStatus, setLearningProgramStatus] = useState<any>();
  const navigate = useNavigate();

  const location = useLocation();
  const pId = Props.cid;
  // const {currentQuarter} = useQuaterDetail();
  const [programStart, setProgramStart] = useState<any>();
  const {state} = useContext(AppContext);
  const [loading, setLoading] = useState(true);
  const [introductionVideo, setIntroductionVideo] = useState<any>();
  const [badgeData, setBadgeData] = useState<any>({relationshipid:"",included:[]});
  const [watchRecordingId, setWatchRecordingId] = useState<any>();

  useEffect(() => {
    const fetchData = async () => {
        let apiResponseData: any = '';
        let isFundamentalProgram = true;
        let renderData: any = {};

        if (pId.indexOf(':') === -1) {
          apiResponseData = await apis.getFundamentalProgramList(state.fundamenalCatlogId);
          renderData = apiResponseData.data[0];
        } else {
          apiResponseData = await apis.getProgramList(pId);
          renderData = apiResponseData.data;
          isFundamentalProgram = false;
          setFundamentalProgram(false);
        }
        setData(renderData);
        setProgramId(renderData?.id);
        setLoading(false);

        let program: any = null;

        const programDetails: any = {};
        let erollmentDate = null;
        let enrollmentData:any=null;
        // fetch program details
        if (isFundamentalProgram) {
          if (apiResponseData?.data[0]?.relationships.enrollment) {
            const enrollmentId = apiResponseData.data[0].relationships.enrollment.data.id;
            enrollmentData = filterEnrollmentData(apiResponseData, enrollmentId);
            erollmentDate = enrollmentData.dateEnrolled;
            setBadgeData({relationshipid:apiResponseData?.data[0]?.relationships?.instances?.data[0]?.id,included:apiResponseData?.included})
          } else {
            navigate(`${APPROUTES.error}/${ErrorType.enrollment}`);
            return
          }
        } else {
          if (apiResponseData.data.relationships.enrollment) {
            const enrollmentId = apiResponseData.data.relationships.enrollment.data.id;
            enrollmentData = filterEnrollmentData(apiResponseData, enrollmentId);
            erollmentDate = enrollmentData.dateEnrolled;
            setUserEnrollmentId(enrollmentId);
            setBadgeData({relationshipid:apiResponseData?.data?.relationships?.instances?.data[0]?.id,included:apiResponseData?.included})
          } else {
            navigate(`${APPROUTES.error}/${ErrorType.enrollment}`);
            return
          }
        }
 
        //check the usr enrollend
        if (erollmentDate) {
          setUserEnrollmentDate(erollmentDate);
        }

        program = renderData?.relationships?.instances?.data;
        if (program) {
          const programList = data?.included?.find((ele: any) => ele.id == program[0].id);

          const content = getLocalizedContent(renderData.attributes?.localizedMetadata);
          programDetails.name = content?.name;
          programDetails.bannerImage = renderData.attributes?.bannerUrl;
          programDetails.coverImage = renderData.attributes?.imageUrl;
          programDetails.completionDeadline = programList?.attributes.completionDeadline;
          programDetails.enrollmentDeadline = programList?.attributes.enrollmentDeadline;
          programDetails.id = programList?.attributes.id;
          programDetails.description = content?.description;
          programDetails.relationships = renderData?.relationships?.instances?.data[0]?.id; //}
          programDetails.tags = renderData?.attributes?.tags;
          programDetails.overview=content?.overview;
          programDetails.richTextOverview=content?.richTextOverview;
          programDetails.programStatus=enrollmentData?.state === constants.COURSE_STATUS 
          setProgramDetailObject(programDetails);
        }

        // get the resources details
        const responseData = renderData?.relationships?.supplementaryResources?.data;
        const resourcePDFLink:any = [];
        const documentArray: any = [];
        responseData?.forEach((ele: any) => {
          const finalArr = responseData.find((item: any) => item.id == ele?.id);
          resourcePDFLink.push(finalArr);
          const data = apiResponseData?.included.find((item: any) => item.id == ele.id);
          if (checkLottie(data?.attributes?.name)) {
            const file = data?.attributes?.name;
            if (file.endsWith(FileNotation.badge)) {
              setProgramBadgeLottieLocation(data?.attributes?.location);
            } else if (file.endsWith(FileNotation.finish)) {
              setProgramFinishLottieLocation(data?.attributes?.location);
            }
          } else {
            documentArray.push(data);
          }
        });
        setClassResource(documentArray);
        //Get badge details
        setBadgeDetailData(getBadgeDetail(apiResponseData, program[0].id));

        // get the week details and course under it
        const res:any= []
        renderData?.attributes?.sections?.forEach((item:any)=>{ res.push(...item.loIds)});
        const courseList = [];
        for (const element of res) {
          const temp: any = {};
          const LPDetails = apiResponseData?.included?.find((ele: any) => ele.id == element);

          const content = getLocalizedContent(LPDetails?.attributes?.localizedMetadata);

          temp.name = content?.name;
          temp.overview = content?.overview;
          temp.id = LPDetails?.id;
          temp.supplementaryResources = LPDetails?.relationships?.supplementaryResources ?? null;
          const courseArray: any = [];

          let hideWeek=false;
          if(LPDetails?.attributes?.tags?.includes(Tag.introductionVideo) || LPDetails?.attributes?.tags?.includes(Tag.overviewIntroVideo) ||  LPDetails?.attributes?.tags?.includes(Tag.doNotShow)){ 
            //Set introduction module
            if(LPDetails?.attributes?.tags?.includes(Tag.introductionVideo))
              setIntroductionVideo(LPDetails.id);
            // hide week detail from listing ui
            hideWeek=true
          }

          temp.visible = !hideWeek;

          if (LPDetails?.attributes?.tags?.includes(Tag.doNotShow)) {
            const doNotShowWeek = apiResponseData.included?.find(
              (ele: any) => ele?.id === LPDetails.id
            );
            const doNotShowWeekRelationshipsEnrollment = apiResponseData.included?.find(
              (ele: any) => ele?.id === doNotShowWeek.relationships.enrollment.data.id
            );
            const loResourceGrades = apiResponseData.included?.find(
              (ele: any) =>
                ele?.id ===
                doNotShowWeekRelationshipsEnrollment?.relationships?.loResourceGrades.data[0]?.id
            );
            setLearningProgramStatus({
              ...loResourceGrades.attributes,
              courseRelationshipsEnrollmentLoResourceGradesId: loResourceGrades.id,
            });
          }

          const learningPathCourseDetails = apiResponseData.included?.find(
            (ele: any) => ele?.id === temp?.id
          );


          if (learningPathCourseDetails) {

            const subLos =
              learningPathCourseDetails?.relationships?.subLOs?.data;

            if (subLos) {
              const sections=learningPathCourseDetails.attributes?.sections;
              const childrenSectionsLoIds:any=[];
              for(const sec of sections){
                for(const ids of sec.loIds){
                  childrenSectionsLoIds.push({id:ids,mandatory:sec?.mandatory})
                }
              }
              for (const element of childrenSectionsLoIds) {

                const courseAttributes: any = {};

                const course = apiResponseData?.included?.find((ele: any) => {
                  return ele.id === element?.id;
                });
                const liveClass =
                  course?.attributes?.tags !== undefined &&
                  course?.attributes?.tags.includes(Tag.liveclass);
                let watchRecording = false;

                if (liveClass) {
                  const courseRelationshipsInstances =
                    apiResponseData?.included?.find((ele: any) => {
                      return (
                        ele.id === course?.relationships.instances.data[0].id
                      );
                    });
                  if (courseRelationshipsInstances?.relationships?.loResources?.data.length === 2) {
                    // show watch recording
                    watchRecording = true;
                    setWatchRecordingId(courseRelationshipsInstances?.relationships?.loResources?.data[1].id)
                  }

                  const courseRelationshipsInstancesLoResources =
                    apiResponseData?.included?.find((ele: any) => {
                      return (
                        ele.id ===
                        courseRelationshipsInstances?.relationships?.loResources
                          ?.data[0]?.id
                      );
                    });
                  //course:2224790_2314767_2691804_0
                  const courseRelationshipsInstancesLoResourcesLiveClass =
                    apiResponseData?.included?.find((ele: any) => {
                      return (
                        ele.id ===
                        courseRelationshipsInstancesLoResources.relationships
                          .resources.data[0].id
                      );
                    });
                  courseAttributes.completionDeadline =
                    courseRelationshipsInstancesLoResourcesLiveClass?.attributes?.completionDeadline;
                  courseAttributes.liveClassdateStart =
                    courseRelationshipsInstancesLoResourcesLiveClass?.attributes?.dateStart;
                }

                const courserelationships = apiResponseData?.included?.find((ele: any) => {
                  return ele.id === course.relationships?.enrollment?.data?.id;
                });
                const content = getLocalizedContent(course?.attributes?.localizedMetadata);
                courseAttributes.name = content?.name;
                courseAttributes.name = content?.name;
                courseAttributes.id = course?.id;
                courseAttributes.description = content?.description;
                courseAttributes.bannerUrl = course?.attributes?.bannerUrl;
                programDetails.courseImage = renderData.attributes?.bannerUrl;
                courseAttributes.state = courserelationships?.attributes?.state;
                courseAttributes.tags = course?.attributes?.tags;
                courseAttributes.isRecordingAvail = watchRecording;
                courseAttributes.coverImage = course?.attributes?.imageUrl;
                courseAttributes.mandatory = element.mandatory;
                courseArray.push(courseAttributes);
              }
            }
          }
          temp.courseArray = courseArray;

          // get the instance details
          const LPInstanceDetails = apiResponseData.included?.find(
            (ele: any) => ele?.id === temp?.id
          );
          const instanceObject: any = {};
          if (LPInstanceDetails) {
            const instances = LPInstanceDetails?.relationships?.instances?.data;
            if (instances) {
              for (const element of instances) {
                const instanceDetails = apiResponseData.included?.find(
                  (ele: any) => ele.id === element?.id
                );
                instanceObject.enrollmentDeadline =
                  instanceDetails?.attributes?.enrollmentDeadline;
              }
            }
          }

          const spData = courseArray?.relationships?.supplementaryResources?.data;
          const spList = [];
          if (spData?.length > 0) {
            const sp: any = {};
            for (let j = 0; j < spData?.length; j++) {
              const res = apiResponseData?.included?.find((ele: any) => ele?.id == spData[j]?.id);
              sp.name = res?.attributes?.name;
              sp.location = res?.attributes?.location;
              spList.push(sp);
            }
          }
          temp.supplementaryResources = spList;
          temp.enrollmentDeadline = instanceObject?.enrollmentDeadline;

          courseList.push(temp);
          setCourseDetails(courseList);
        }

        const jobAidsID = renderData.relationships?.supplementaryLOs?.data[0].id;
        setJobAids(jobAidsID);
    };
    fetchData();
  }, []);

  // function to play course/content passing ID in fluidic player
  const playIntroductionVideo = () => {
    if (introductionVideo) {
      setPlayCourse(true);
    } else {
      toast({  description: t('Common.errorPlayingVideo'), variant: 'error'});
    }
  };
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
    if (history.scrollRestoration) {
      history.scrollRestoration = 'manual';
    }
  }, []);

  useEffect(() => {
    if (state.enrollmentData && programDetailObject?.tags?.length) {
      const quarter = Object.keys(state.enrollmentData).filter(key => {
        const qu = `${state.enrollmentData[key]?.quarter}-${state?.enrollmentData[key]?.year}`;
        return programDetailObject?.tags.includes(qu as never);
      })[0];
      const programQuarter = state.enrollmentData[quarter];
      const programQuarterStart = programQuarter?.start ? programQuarter?.start : null;
      setProgramStart(programQuarterStart)
    }
  }, [state, programDetailObject]);
  const hidePageLoader=()=>{
    setLoading(false)
  }
  return (
    <>
      {loading ? (
        <PageLoader />
      ) : (
        <>
          {
            playCourse && (
              <FullScreenPlayer
                cid={introductionVideo}
                goBackUrl={location.pathname}
                fullScreen={true}
                playVideo={setPlayCourse}
              />
            ) 
          }

          {programDetailObject && (
            <ProgramIntroContent
              programDetailObject={programDetailObject}
              jobAids={jobAids}
              playVideo={playIntroductionVideo}
              userEnrollmentId={userEnrollmentId}
              programStart={programStart}
              badgeDetailData={badgeDetailData}
              badgeData={badgeData}
              introductionVideo={introductionVideo}
              currentQuarterStartDate={state.quarterDeatil?.currentQuarter?.start}
              nextQuarterStartDate={state?.quarterDeatil?.nextQuarter?.start}
              userEnrollmentDate={userEnrollmentDate}
            />
          )}
          {programDetailObject && (
            <ProgramInstructions
              programDetailObject={programDetailObject}
              courseDetails={courseDetails}
              programBadgeLottieLocation={programBadgeLottieLocation}
              pId={programId}
              userEnrolmentDate={userEnrollmentDate}
              isFundamentalProgram={fundamentalProgram}
              learningProgramStatus={learningProgramStatus}
              programStart={programStart}
              programFinishLottieLocation={programFinishLottieLocation}
              currentQuarter={state.quarterDeatil?.currentQuarter}
              hidePageLoader={hidePageLoader}
              badgeDetailData={badgeDetailData}
              watchRecordingId={watchRecordingId}
          />
          )}
          {classResource.length > 0 && <ClassResources classResource={classResource} />}
          {programId && <RelatedContent courseId={programId}/>}
        </>
      )}
    </>
  );
};

export default ProgramIntro;
